var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFreeTrialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.094 18.328C10.966 18.328 9.982 18.142 9.142 17.77C8.314 17.386 7.6 16.828 7 16.096L8.422 14.008C9.058 14.752 9.676 15.274 10.276 15.574C10.888 15.874 11.548 16.024 12.256 16.024C12.628 16.024 12.958 15.976 13.246 15.88C13.546 15.772 13.78 15.622 13.948 15.43C14.116 15.238 14.2 15.01 14.2 14.746C14.2 14.554 14.158 14.38 14.074 14.224C13.99 14.056 13.87 13.912 13.714 13.792C13.558 13.66 13.372 13.546 13.156 13.45C12.94 13.342 12.7 13.252 12.436 13.18C12.172 13.096 11.884 13.03 11.572 12.982C10.672 12.79 9.922 12.52 9.322 12.172C8.734 11.824 8.29 11.392 7.99 10.876C7.702 10.36 7.558 9.748 7.558 9.04C7.558 8.5 7.678 8.002 7.918 7.546C8.158 7.078 8.488 6.676 8.908 6.34C9.34 6.004 9.832 5.746 10.384 5.566C10.948 5.386 11.542 5.296 12.166 5.296C13.174 5.296 14.062 5.464 14.83 5.8C15.61 6.124 16.282 6.628 16.846 7.312L15.55 9.184C15.106 8.668 14.596 8.278 14.02 8.014C13.456 7.75 12.856 7.618 12.22 7.618C11.824 7.618 11.482 7.672 11.194 7.78C10.906 7.876 10.678 8.02 10.51 8.212C10.354 8.404 10.276 8.638 10.276 8.914C10.276 9.13 10.33 9.322 10.438 9.49C10.546 9.658 10.702 9.808 10.906 9.94C11.11 10.06 11.356 10.168 11.644 10.264C11.932 10.36 12.25 10.444 12.598 10.516C13.258 10.648 13.852 10.822 14.38 11.038C14.908 11.254 15.358 11.518 15.73 11.83C16.114 12.13 16.408 12.49 16.612 12.91C16.816 13.318 16.918 13.78 16.918 14.296C16.918 15.148 16.714 15.874 16.306 16.474C15.898 17.074 15.334 17.536 14.614 17.86C13.894 18.172 13.054 18.328 12.094 18.328ZM11.014 19.786L11.158 11.47L12.688 12.064L12.832 19.786H11.014ZM13.228 12.082L11.698 11.488L11.554 4H13.372L13.228 12.082Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeTrialIcon);
export default __webpack_public_path__ + "static/media/freeTrialIcon.2eaf7bef12744c5e3a58794ca49e717d.svg";
export { ForwardRef as ReactComponent };